module.exports = __webpack_public_path__ + "img/edit.2216bcf8.svg";